export function getCalendarViewForRange(selectedRangeDays) {
  return selectedRangeDays === 30 ? "month" : "week";
}

export function getCalendarEventTitle(assignment) {
  return (
    assignment.teamName ||
    assignment.teamId ||
    assignment.title ||
    "Scheduled class"
  );
}

export function mapAssignmentsToCalendarEvents(assignments) {
  return (assignments || [])
    .map((assignment) => {
      const start = new Date(assignment.start);
      const end = new Date(assignment.end);

      return {
        id: `${assignment.eventId || assignment.rawId || assignment.transactionId || getCalendarEventTitle(assignment)}-${assignment.start}`,
        title: getCalendarEventTitle(assignment),
        start,
        end,
        allDay: false,
        resource: assignment,
      };
    })
    .filter(
      (event) =>
        !Number.isNaN(event.start.getTime()) &&
        !Number.isNaN(event.end.getTime())
    );
}
